import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box, ClickAwayListener, IconButton, Tooltip, Typography } from '@mui/material';
import { Logout, AccountCircle } from '@mui/icons-material';
import { alertActions, authActions, userProfileAction, activityLogAction } from '_store';
import { useNavigate } from 'react-router-dom';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Accordion, AccordionSummary, AccordionDetails, Paper, Button } from "@mui/material";
import { NewPassword, ResetProfilePassword } from 'container/loginPage';
import { profileuser } from '../../images';
import { MyProfileMC, MyProfileSD } from './index';
import { ModalPopup } from '_components';
import {useCheckRole } from '_utils/role-access';
import { ERR_MSG, LOGOUT_MSG } from 'constants/labels';

const MyProfile = ({ showHeaderMenu ,isAdmin}) => {
    const header = "My Profile";
    const dispatch = useDispatch();
    const logout = () => dispatch(authActions.logout());
    const auth = useSelector(x => x.auth.value);
    const id = useSelector(x => x.auth?.userId);
    const data = auth?.Data;
    const user = data?.UserDetails;
    const userAccess = data?.UserAccess;
    const isReviewer = userAccess?.some(access => access.Role.toLowerCase().includes('reviewer'));
    const authUserName = `${user.firstName} ${user.lastName}`;
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [isResetPassword, setIsResetPassword] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isModalDeleteOpen, setIsModalDeleteOpen] = useState(false);
    // const open = Boolean(anchorEl);
    const [open, setOpen] = useState(false);

    const portalID =
      (sessionStorage.getItem("portalID") ??
        sessionStorage.getItem("portalID")) ||
      99;
    const portal = portalID !== 99 && userAccess.find(x => x.PortalId.toString() === portalID);
    const portalKey = portal && portal.PortalKey || null;
    const role = portal?.Role;
    const [name, setName] = useState();
    //const portalKey = userAccess.find(x => x.PortalKey);
    const [expandedAccordion, setExpandedAccordion] = useState("");
      const hasResetPasswordSelfRole = useCheckRole(portalID, "ResetPasswordSelf");
      const hasDeleteProfileSelffRole = useCheckRole(portalID, "DeleteProfileSelf");
      const hasLogoutRole = useCheckRole(portalID, "Logout");
    const showComponent = true;

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleLogOut = () => {
        handleClose();
        logout();
        dispatch(alertActions.success({ message: LOGOUT_MSG, header: "Log Out", showAfterRedirect: true }));
    };
    const handleAccordionChange = (panel) => (event, isExpanded) => {
        setExpandedAccordion(isExpanded ? panel : false);
    };

    const handleOpenModal = () => setIsModalOpen(true);
    const handleCloseModal = () => {
        setIsModalOpen(false);
        setIsResetPassword(false);
    }

    const handleResetPasword = () => {
        handleClose();
        setIsResetPassword(true);
        setIsModalOpen(true)
    }

    const handleOpenDeleteModal = () => {
        setIsModalDeleteOpen(true);
    };

    const handleCloseDeleteModal = () => {
        setIsModalDeleteOpen(false);
    };

    const handleClickAway = () => {
        setOpen(false);
    };
    useEffect(() => {
        if (open) {
            document.body.classList.add('menu-open');
        } else {
            document.body.classList.remove('menu-open');
        }

        // Cleanup on unmount
        return () => {
            document.body.classList.remove('menu-open');
        };
    }, [open]);

    const handleDelete = async () => {
      dispatch(alertActions.clear());
      try {
        // Transform the deleted profiles for further processing
        const transformedData = [
          {
            UserID: id,
            UpdatedBy: authUserName,
          },
        ];

        if (transformedData.length > 0) {
          await dispatch(userProfileAction.delete(transformedData)).unwrap();
          handleCloseDeleteModal();
          handleLogOut();
          dispatch(
            alertActions.success({
              message: "Your profile has been deleted successfully.",
              header: header,
              showAfterRedirect: true,
            }),
          );
        }
      } catch (error) {
        handleCloseDeleteModal();
        dispatch(
          alertActions.error({
            message: error.message ? ERR_MSG["073"] : error,
            header,
          }),
        );
      }
    };
    return (
        <React.Fragment>
            <Box sx={{ display: 'flex', alignItems: 'center', textAlign: 'center' }}>
                <Tooltip title="Account">
                    <IconButton
                        // onClick={handleClick}
                        onClick={() => setOpen(!open)}
                        size="small"
                        sx={{ ml: 2 }}
                        aria-controls={open ? 'account-menu' : undefined}
                        aria-haspopup="true"
                        aria-expanded={open ? 'true' : undefined}
                    >
                        <img src={profileuser} alt='profileuser' />
                        {/* <AccountCircle className='fontsizeicon' /> */}
                        {/* <Avatar sx={{ width: 32, height: 32 }}>P</Avatar> */}
                    </IconButton>
                </Tooltip>
                {open && (
                    <ClickAwayListener onClickAway={handleClickAway}>
                        <Paper
                            className='profilenavbar support-list'
                            elevation={4}
                            sx={{
                                mt: 2,
                                p: 2,
                                maxWidth: "300px",
                                mx: "auto",
                                backgroundColor: "#f5f5f5",
                            }}
                        >
                            {(!isAdmin && !isReviewer && showHeaderMenu) && (
                                <> <Accordion
                                    expanded={expandedAccordion === "Personalinfo"}
                                    onChange={handleAccordionChange("Personalinfo")}
                                >
                                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                        <Typography variant="h6" className='profileName'>My Profile </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        {(portalKey && portalKey?.toLowerCase() === "mc") ? <MyProfileMC /> : <MyProfileSD portalKey={portalKey} portalID={portalID} />}
                                    </AccordionDetails>
                                </Accordion>
                                   {hasResetPasswordSelfRole && <Button className='ResetPasswordbutton' onClick={() => handleResetPasword()}>
                                        Reset Password
                                    </Button>}
                                    {portalKey === "MC" && role === "Map Requestor" || !hasDeleteProfileSelffRole ? null : (
                                        <Button className='ResetPasswordbutton' onClick={() => handleOpenDeleteModal()}>
                                            Delete Profile
                                        </Button>
                                    )}
                                    </>
                            )}
                           {(isAdmin || isReviewer) && <Typography variant="h6" className='ResetPasswordbutton'>{authUserName}</Typography>}
                                    <Button className='ResetPasswordbutton' onClick={() => handleLogOut()}>
                                        Logout
                                    </Button>                           
                        </Paper>
                    </ClickAwayListener>
                )}
            </Box>
            {/* "support-list profilenavbar" */}
            {isModalDeleteOpen && <ModalPopup
                header="Profile Delete"
                message1="Are you sure you want to delete your profile? This action is irreversible and will permanently remove all your data from the system."
                btnPrimaryText="Confirm"
                btnSecondaryText="Cancel"
                handlePrimaryClick={() => handleDelete()}
                handleSecondaryClick={() => handleCloseDeleteModal()}
            />
            }

            {/* {isResetPassword && <NewPassword usersID={id} isModalOpen={isModalOpen}
                handleCloseModal={() => handleCloseModal()}></NewPassword>} */}
             {isResetPassword && <ResetProfilePassword usersID={id} isModalOpen={isModalOpen}
                handleCloseModal={()=>handleCloseModal()}></ResetProfilePassword>} 
        </React.Fragment>
    );
}

export default MyProfile;